import { render, staticRenderFns } from "./BarraTopo.vue?vue&type=template&id=601488ca&scoped=true&"
import script from "./BarraTopo.vue?vue&type=script&lang=js&"
export * from "./BarraTopo.vue?vue&type=script&lang=js&"
import style0 from "./BarraTopo.vue?vue&type=style&index=0&id=601488ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601488ca",
  null
  
)

export default component.exports